import React from "react";
import { useTranslation } from "react-i18next";
import { identity, selectKeys } from "shared/src/util.mjs";
import * as d from "shared/src/date.mjs";
import * as f from "../utils/formatter";

const formatters = {
  client: {
    birthdate: (v) => f.date(d.parseDateTime(v)),
  },
};

function format(entity, k, v) {
  const f = formatters[entity]?.[k] ?? identity;

  return f(v);
}

export function ObjectValues({ entity, data }) {
  const { t } = useTranslation();

  if (data == null) {
    return null;
  }

  return Object.entries(data).map(([k, v]) => {
    return (
      <div key={k}>
        <strong>{t(`entity.${entity}.${k}`)}</strong>: {format(entity, k, v)}
      </div>
    );
  });
}

function rowData(audit) {
  if (audit.action === "U") {
    return selectKeys(audit.row_data, Object.keys(audit.changed_fields));
  }

  return audit.row_data;
}

export function RowData({ audit }) {
  return <ObjectValues entity={audit.relid} data={rowData(audit)} />;
}

export function ChangedFields({ audit }) {
  return <ObjectValues entity={audit.relid} data={audit.changed_fields} />;
}
